import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region redux
import { useDispatch } from "react-redux";
import { ThunkDispatch } from "redux-thunk";
import { setMessageClass } from "store/actions/utilActions";
//#endregion
//#region types
import { DrawerRightHandles, DrawerRightProps } from "models/propTypes/drawerPropTypes";
import { HTMLConstants, IconDefinitionConstants, EventConstants } from "utils/constants";
import { WintUtilsWebApi } from "wint-api-client/dist/types";
import { ListAPIResponse } from "models/propTypes/simpleTableProps";
import { SubComponentType } from "models/enums/common";
//#endregion
//#region components
import { Button, Drawer } from "@mui/material";
import useFloatingMessages from "../messages/useFloatingMessages";
import Icon from "../icon";
import { ErrorBoundary } from "components/error";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { EventHelper } from "utils/helpers";

const DrawerRight: ForwardRefRenderFunction<DrawerRightHandles, React.PropsWithChildren<DrawerRightProps>> = (
  props,
  ref
) => {
  const dispatch: ThunkDispatch<any, any, any> = useDispatch();
  const { closeMessage } = useFloatingMessages();

  const [isOpen, setIsOpen] = React.useState<boolean>(false);

  React.useEffect(() => {
    EventHelper.subscribeEvent(EventConstants.CloseDrawer, closeDrawer);

    return () => {
      EventHelper.unsubscribeEvent(EventConstants.CloseDrawer, closeDrawer);
    };
  }, [props.onClose]);

  React.useImperativeHandle(ref, () => ({
    openDrawer: (
      toOpenIndex?: number,
      filter?: <T extends WintUtilsWebApi.Filter>(filter: T, key?: number) => ListAPIResponse<any>
    ) => {
      props.onOpen && props.onOpen(toOpenIndex, filter);
      setIsOpen(true);
    },

    closeDrawer: () => {
      closeDrawer();
    },
  }));

  const closeDrawer = () => {
    setIsOpen(false);
    props.onClose && props.onClose();
    closeMessage();
    dispatch(setMessageClass(""));
  };

  return (
    <>
      <div id={HTMLConstants.DrawerFilePortalId} className={cssExports.drawerImagePreviewPortal}></div>
      <ErrorBoundary subComponentType={SubComponentType.Drawer}>
        <Drawer
          anchor={"right"}
          open={isOpen}
          classes={{ paper: cssExports.drawerOuter }}
          transitionDuration={500}
          onClose={closeDrawer}
        >
          <Button className={cssExports.drawerCloseIcon} onClick={closeDrawer} disableRipple>
            <Icon icon={IconDefinitionConstants.WTimesThin} />
          </Button>
          <ErrorBoundary subComponentType={SubComponentType.Drawer}>{props.children}</ErrorBoundary>
        </Drawer>
      </ErrorBoundary>
    </>
  );
};

export default forwardRef(DrawerRight);
